module.exports = __webpack_public_path__ + "static/grafika3@2x-ef64c50b5146a0b1290e7c414038f223.png";